export default __webpack_public_path__ + "static/media/cac229a163c10293fb20e98a883e0b53.jpg";